import { PubSub } from "@/utils/pub-sub";
import { App } from "@vue/runtime-core";

export enum NotificationType {
  INFO = "info",
  SUCCESS = "success",
  WARNING = "warning",
  ALERT = "alert",
}

type Message = {
  type: NotificationType;
  message: string;
};

type Callback = (message: Message) => void;

class Notifications {
  private readonly pubSub: PubSub<Message>;

  constructor() {
    this.pubSub = new PubSub<Message>();
  }

  addAlert(message: string): void {
    this.add(NotificationType.ALERT, message);
  }

  // `addSuccess` was already being called from the registration forms and the
  // withdraw flow, but it never existed here — those call sites guard it with
  // `$notifications.addSuccess && ...`, so every success message was silently
  // dropped. The guards can stay; they are harmless now that it resolves.
  addSuccess(message: string): void {
    this.add(NotificationType.SUCCESS, message);
  }

  addWarning(message: string): void {
    this.add(NotificationType.WARNING, message);
  }

  addInfo(message: string): void {
    this.add(NotificationType.INFO, message);
  }

  add(type: NotificationType, message: string): void {
    this.pubSub.publish({ type, message });
  }

  subscribe(callback: Callback): string {
    return this.pubSub.subscribe(callback);
  }

  unsubscribe(token: string): void {
    this.pubSub.unsubscribe(token);
  }
}

export default {
  install: (app: App) => {
    app.config.globalProperties.$notifications = new Notifications();
  },
};
